/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import FormInput from "./FormInput";
import Card from "./Card";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Tutorial from "../shared/Tutorial";
import { SidebarGlobal } from "./_SidebarGlobal";
import MessageDialog from "./MessageDialog";

class OrderNew extends BaseCom {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            item: {
                patient: {}
            },
            accountList: [],
            reqList: [],
            saving: false
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onSelectProvider = this.onSelectProvider.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/account/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list) {
                if (j.list.length === 1)
                    this.state.item.accountID = j.list[0].id;
                this.setState({ accountList: j.list, loaded: true, item: this.state.item });
            }
        });

        Tutorial.complete('patient-new');
    }

    onSelectProvider(v) {

    }

    onSubmit(e) {
        if (e)
            e.preventDefault();
        this.setState({ saving: true });
        qreq.post('/api/order/create', this.state.item, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else {
                //this.props.navigate('/order/list/documents/' + j.item.id);
                this.props.navigate('/order/edit/' + j.item.id + '/patient');
            }
            this.setState({ saving: false });
        }, () => this.setState({ saving: false }));
    }

    render() {
        const header = (<h1>New {this.T('subject')}</h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>)

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" disabled={this.state.saving} onClick={() => document.getElementById('c-submit').click()}><L>Continue</L><FontAwesomeIcon icon={fa.faArrowRight} /></button></>);

        return (<div className="container-fluid">{header}<form onSubmit={this.onSubmit}><Card title="Requisition">
            {this.state.accountList.length !== 1 ? <FormInput model={this.state.item} name="accountID" label="Account" type="select" options={this.state.accountList} required={true} /> : ''}
            <p className="mb-3">Enter the first and last name of the {this.T('subject')} below to proceed and upload the request documents.</p>
            <div className="row">
                <div className="col">
                    <FormInput model={this.state.item.patient} label="First Name" name="firstName" type="text" required={true} />
                </div>
                <div className="col">
                    <FormInput model={this.state.item.patient} label="Last Name" name="lastName" type="text" required={true} />
                </div>
            </div>
            {this.state.saving ? <MessageDialog title="Creating" message="Please wait..." /> : ''}
            <div className="btn-group">
                <button id="c-submit" type="submit" className="btn btn-primary" disabled={this.state.saving}><L>Continue</L><FontAwesomeIcon icon={fa.faArrowRight} /></button>
            </div>
        </Card></form></div>);
    }

}

export default withParamsAndNavigate(OrderNew);